import cookie from "js-cookie";

// Set in Cookie
export const setCookie = (key, value) => {
  if (window !== "undefiend") {
    cookie.set(key, value, {
      // 1 Day
      expires: 1,
    });
  }
};

// Remove from Cookie
export const removeCookie = (key) => {
  if (window !== "undefiend") {
    cookie.remove(key, {
      // 1 Day
      expires: 1,
    });
  }
};

// Get from cookie like token
export const getCookie = (key) => {
  if (window !== "undefiend") {
    return cookie.get(key);
  }
};

// Set in localstorage
export const setLocalStorage = (key, value) => {
  if (window !== "undefiend") {
    localStorage.setItem(key, JSON.stringify(value));
  }
};

// Remove form  localstorage
export const removeLocalStorage = (key) => {
  if (window !== "undefiend") {
    localStorage.removeItem(key);
  }
};

// Auth user after login
export const authenticate = (response, next) => {
  setCookie("token", response.data.token);
  setLocalStorage("user", response.data.user);
  next();
};

// Signout
export const signout = (next) => {
  removeCookie("token");
  removeLocalStorage("user");
};

// Get user info for localstorage
export const isAuth = () => {
  if (window !== "undefined") {
    const cookieChecked = getCookie("token");
    if (cookieChecked) {
      if (localStorage.getItem("user")) {
        return JSON.parse(localStorage.getItem("user"));
      } else {
        return false;
      }
    }
  }
};

// Update user data in localstorage
export const updateUser = (response, next) => {
  if (window !== "undefiend") {
    let auth = JSON.parse(localStorage.getItem("user"));
    auth = response.data;
    localStorage.setItem("user", JSON.stringify(auth));
  }
  next();
};
